import { render, staticRenderFns } from "./CadastroCliente.vue?vue&type=template&id=50a06706&"
import script from "./CadastroCliente.vue?vue&type=script&lang=js&"
export * from "./CadastroCliente.vue?vue&type=script&lang=js&"
import style0 from "./CadastroCliente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports